import { GridCellProps } from '@progress/kendo-react-grid';
import { useTranslation } from 'react-i18next';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { CompanySearchResult } from 'src/types/work_area';

const ContactNameCell = (props: GridCellProps) => {
  const { t } = useTranslation();
  const { dataItem } = props;
  const { displayValue } = useGridCellDisplayValue(props);
  const row = dataItem as CompanySearchResult;
  const showDisabledTag = row?.isClientDeleted === true;

  return (
    <GridCellBase {...props} title={displayValue}>
      {showDisabledTag ? (
        <div className="flex items-center justify-between gap-2 min-w-0">
          <span className="min-w-0 truncate">{displayValue}</span>
          <span className="flex-shrink-0 rounded bg-red-50 px-2 py-0.5 text-[11px] font-medium text-red-600">
            {t('disabled')}
          </span>
        </div>
      ) : (
        <span className="min-w-0 truncate">{displayValue}</span>
      )}
    </GridCellBase>
  );
};

export default ContactNameCell;
